export default {
  compareHub: {
    seo: {
      title: 'Compare logistics software | Geofleet — agentic platform for execution',
      description:
        'See how Geofleet compares to route optimizers, last-mile tools, and enterprise delivery platforms. Overview table plus dedicated pages for each vendor—built as the agentic logistics platform for real-world execution.',
    },
    breadcrumb: 'Compare',
    hero: {
      lockupPartner: 'Other platforms',
      eyebrow: 'Platform comparison',
      h1Before: 'Compare logistics software—then choose an',
      h1Highlight: 'agentic',
      h1After: 'execution layer',
      leadBefore: 'Most tools',
      leadEmphasis1: 'plan or notify',
      leadMiddle: '. Geofleet is built to',
      leadEmphasis2: 'run operations',
      leadAfter:
        ': AI Agents in one command centre keep drivers, carriers, and customers aligned as conditions change—without a patchwork of dashboards and manual replans.',
      ctaTable: 'View comparison table',
      ctaTrial: 'Get started',
      ctaDemo: 'Book a demo',
    },
    howToLabel: 'How to use this page',
    steps: {
      overview: {
        title: 'Start with the overview',
        body: 'See how Geofleet differs from typical routing, delivery, and legacy stacks in one table.',
      },
      vendor: {
        title: 'Go deep on your vendor',
        body: 'Pick the tool you use today—each page is a focused Geofleet vs vendor breakdown.',
      },
      validate: {
        title: 'Validate on your network',
        body: 'Book a demo to map hubs, carriers, and volumes to the command centre and AI Agents.',
      },
    },
    pills: {
      command: {
        title: 'AI Command Centre',
        sub: 'Agents run dispatch, routing & exceptions together',
      },
      live: {
        title: 'Live execution',
        sub: 'Allocation and routes update as the network changes',
      },
      stack: {
        title: 'Full mileage story',
        sub: 'Hubs, portals, tracking & analytics in one stack',
      },
    },
    tableSection: {
      title: 'At a glance: agentic execution vs typical stacks',
      description:
        'Vendors differ—use the grid below for your exact tool. This table captures recurring gaps we see when teams outgrow point solutions and need one automation layer across the network.',
      badge: 'Honest aggregate view',
    },
    vendorsSection: {
      eyebrow: 'Head-to-head pages',
      title: 'Find your current vendor',
      description:
        'Each link opens a dedicated comparison: what the vendor does well, where Geofleet goes deeper, and when an agentic logistics platform is the better fit.',
      vsPrefix: 'Geofleet vs',
      alternativeSuffix: 'alternative',
      openLink: 'Open comparison',
    },
    cta: {
      headline: 'See Geofleet on your network',
      subtext:
        'Walk through the AI Command Centre, allocation, and agentic routing with your hubs, carriers, and SLAs—not a generic slide deck.',
    },
    faqTitle: 'FAQs',
    faqs: [
      {
        question: 'What is an agentic logistics platform?',
        answer:
          'An agentic platform uses AI Agents and a command centre to orchestrate work autonomously: allocation, routing, replanning, alerts, and customer comms react to live conditions instead of relying only on static rules or manual dispatch clicks.',
      },
      {
        question: 'How does Geofleet compare to route optimization tools?',
        answer:
          'Route optimizers focus on sequencing stops. Geofleet treats routing as part of full execution—auto allocation across drivers and carriers, multi-leg and hub flows, shipper and carrier portals, tracking, and analytics—so optimized plans actually hold up in operations.',
      },
      {
        question: 'How does Geofleet compare to last-mile delivery software?',
        answer:
          'Last-mile tools often center on tasks, drivers, or local delivery. Geofleet targets logistics automation end to end, including middle and first mile where needed, partner ecosystems, and SLA governance at scale.',
      },
      {
        question: 'Where can I see a head-to-head with a specific vendor?',
        answer:
          'Scroll to the vendor grid—each card links to a dedicated Geofleet vs vendor page with feature-level detail and honest tradeoffs.',
      },
      {
        question: 'Should I book a demo to compare options?',
        answer:
          'Yes. Demos are the fastest way to map your hubs, carriers, volumes, and integrations to Geofleet’s command centre and AI Agents.',
      },
    ],
  },
};
